module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "idle-view",
    class: {
      isIdle: _vm.isIdle
    }
  }, [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('sprite', {
    ref: "sprite",
    attrs: {
      "spriteId": "touch",
      "spriteSrc": require('../assets/touch.png'),
      "spriteW": 180,
      "spriteH": 215
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcc562a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Idle.vue
// module id = 13
// module chunks = 0